import { Component } from '@angular/core';
import { LoaderService } from './shared/services/common/loader/loader.service';
import { VERSION } from './shared/constants';
import { environment } from '../environments/environment';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent {
	title = 'HDFC Open Trading Account';

	showLoader: boolean = false;
	showHeader: boolean = true;

	constructor(
		private router: Router,
		public loaderService: LoaderService
	) {
		console.log("Version: " + VERSION);

		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe(({ urlAfterRedirects }: NavigationEnd) => {
				if (urlAfterRedirects.startsWith('/open-trading-account20') || urlAfterRedirects.startsWith('/open-trading-account21') ||urlAfterRedirects.startsWith('/equitas'))
					this.showHeader = false;
			});
	}

	ngOnInit(): void {
		var me = this;
		this.loaderService.isLoading.subscribe((val: boolean) => {
			setTimeout(() => me.showLoader = val);
		});

		$(document).ready(function () {

			if (environment.production) {
				//for disable right click
				$(document).bind("contextmenu", function (e) {
					return false;
				});
			}
		});
	}

	onActivate(event) {
		window.scroll(0, 0);
		//or document.body.scrollTop = 0;
		//or document.querySelector('body').scrollTo(0,0)
		// ...
	}
}
